import React from 'react'

import Reflux from 'reflux-react-16'
import {Route} from 'react-router-dom'

import LoginStore from '../../../stores/LoginStore.js'
import LoginActions from '../../../actions/LoginActions.js'
import AddressStore from '../../../stores/AddressStore.js'

import {Alert, Button, Panel, ListItem, Row, Link} from '../../../components/UI/index.js'
import AccountSettings from './AccountSettings.js'
import ParcelSettings from './ParcelSettings.js'
import CommunicationSettings from './CommunicationSettings.js'
import ReturnSettings from './ReturnSettings.js'
import ConnectionSettings from './Connections/Layout.js'
import AddressBookSetings from './AddressBookSettings.js'
import {navOffset} from '../../../components/navigation/navPosition.js'

class Settings extends Reflux.Component {
    constructor(props) {
        super(props)
        this.state = {
            saving: false,
            saved: false,
            error: ''
        }

        this.stores = [LoginStore, AddressStore]
    }

    componentDidMount() {
        const {history} = this.props

        if (history.location.pathname === '/klant/instellingen' || history.location.pathname === '/klant/instellingen/') {
            history.replace('/klant/instellingen/bedrijfsgegevens')
        }
    }

    componentDidUpdate() {
        const {history} = this.props

        if (history.location.pathname === '/klant/instellingen' || history.location.pathname === '/klant/instellingen/') {
            history.replace('/klant/instellingen/bedrijfsgegevens')
        }
    }

    componentWillUnmount() {
        super.componentWillUnmount.call(this)
        clearTimeout(this.state.timeout)
    }

    updateUser(user, save, callback) {
        this.setState({user, saved: false}, () => {
            if (save) {
                this.saveSettings(null, callback)
            }
        })
    }

    saveSettings(event, callback) {
        event?.preventDefault()

        this.setState({saving: true}, () => {
            setTimeout(() => { // wait for Editor blur onChange
                const {user} = this.state

                LoginActions.updateUserSettings(user, (err, newUser) => {
                    if (err) {
                        this.setState({error: err, saving: false})
                    } else {
                        const timeout = setTimeout(() => {
                            this.setState({saved: false})
                        }, 5000)

                        if (user.settings.logoFileId !== newUser.settings.logoFileId) {
                            location.reload()
                        }

                        this.setState({saving: false, saved: true, error: '', timeout})
                        typeof callback === 'function' && callback()
                    }
                })
            }, 100)
        })
    }

    onNavigate(link) {
        const {history} = this.props
        history.push(link)
    }

    render() {
        const {user, saving, saved, error, addressBook} = this.state
        const {reseller, history} = this.props
        const {pathname} = history.location

        return (
            <div style={{display: 'flex', justifyContent: 'flex-start', minHeight: '100%'}}>
                <Panel style={{display: 'flex', flexDirection: 'column', width: 300, borderTop: 'none', borderLeft: 'none', borderBottom: 'none', overflowY: 'auto'}}>
                    <ListItem
                        active={pathname === '/klant/instellingen/bedrijfsgegevens'}
                        icon='mdi mdi-domain'
                        onClick={this.onNavigate.bind(this, '/klant/instellingen/bedrijfsgegevens')}
                    >
                        Bedrijfsgegevens
                    </ListItem>

                    {user.permissions.parcels &&
                        <ListItem
                            active={pathname === '/klant/instellingen/zendingen'}
                            icon='mdi mdi-package-variant-closed'
                            onClick={this.onNavigate.bind(this, '/klant/instellingen/zendingen')}
                        >
                            Zendingen
                        </ListItem>
                    }

                    {user.permissions.parcels &&
                        <ListItem
                            active={pathname === '/klant/instellingen/emailnotificaties'}
                            icon='mdi mdi-email'
                            onClick={this.onNavigate.bind(this, '/klant/instellingen/emailnotificaties')}
                        >
                            Email notificaties
                        </ListItem>
                    }

                    {user.permissions.parcels && reseller.settings.parcels.products?.Retour && Object.keys(reseller.settings.parcels.products?.Retour).some((carrier) => reseller.settings.parcels.products?.Retour?.[carrier]) &&
                        <ListItem
                            active={pathname === '/klant/instellingen/retouren'}
                            icon='mdi mdi-arrow-u-left-top'
                            onClick={this.onNavigate.bind(this, '/klant/instellingen/retouren')}
                        >
                            Retouren
                        </ListItem>
                    }

                    <ListItem
                        active={pathname === '/klant/instellingen/koppelingen'}
                        icon='mdi mdi-link-variant'
                        onClick={this.onNavigate.bind(this, '/klant/instellingen/koppelingen')}
                    >
                        Koppelingen
                    </ListItem>

                    {pathname.indexOf('/klant/instellingen/koppelingen') !== -1 &&
                        <>
                            <ListItem
                                style={{paddingLeft: 50}}
                                active={pathname === '/klant/instellingen/koppelingen/api'}
                                icon='mdi mdi-api'
                                onClick={this.onNavigate.bind(this, '/klant/instellingen/koppelingen/api')}
                            >
                                API
                            </ListItem>

                            {user.permissions.parcels &&
                                <ListItem
                                    style={{paddingLeft: 50}}
                                    active={pathname === '/klant/instellingen/koppelingen/webshops'}
                                    icon='mdi mdi-cart'
                                    onClick={this.onNavigate.bind(this, '/klant/instellingen/koppelingen/webshops')}
                                >
                                    Webshops
                                </ListItem>
                            }
                        </>
                    }

                    <ListItem
                        active={pathname === '/klant/instellingen/adresboek'}
                        icon='mdi mdi-book-account-outline'
                        onClick={this.onNavigate.bind(this, '/klant/instellingen/adresboek')}
                    >
                        Adresboek
                    </ListItem>

                    <Row style={{flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-start', flex: 1, marginTop: 36, paddingLeft: 12, marginBottom: 12}}>
                        <Link style={{fontWeight: 'normal'}} href='https://veloyd.nl/algemene-voorwaarden/'>Algemene voorwaarden</Link>
                        <Link style={{fontWeight: 'normal'}} rel='privacy-policy' href='https://veloyd.nl/privacy-policy/'>Privacy Policy</Link>
                    </Row>
                </Panel>

                <div style={{height: '100%', overflow: 'auto', width: '100%'}}>
                    {saved && <Alert onClose={() => this.setState({saved: false})} style={{marginBottom: 6, position: 'fixed', zIndex: 100, width: `calc(100vw - ${300 + navOffset().left}px)`}} variant='success'>Je wijzigingen zijn opgeslagen</Alert>}
                    {error && <Alert onClose={() => this.setState({error: ''})} style={{marginBottom: 6, position: 'fixed', zIndex: 100, width: 'inherit'}} variant='error'>{error}</Alert>}

                    <div style={{margin: 30}}>
                        <Route path='/klant/instellingen/bedrijfsgegevens' render={() => <AccountSettings reseller={reseller} user={user} onChange={this.updateUser.bind(this)} />} />
                        {user.permissions.parcels &&
                            <Route path='/klant/instellingen/zendingen' render={() => <ParcelSettings reseller={reseller} user={user} onChange={this.updateUser.bind(this)} />} />
                        }
                        {user.permissions.parcels &&
                            <Route path='/klant/instellingen/emailnotificaties' render={() => <CommunicationSettings location={this.props.location} reseller={reseller} user={user} onChange={this.updateUser.bind(this)} />} />
                        }
                        {reseller.settings.parcels.products?.Retour && Object.keys(reseller.settings.parcels.products?.Retour).some((carrier) => reseller.settings.parcels.products?.Retour?.[carrier]) &&
                            <Route path='/klant/instellingen/retouren' render={() => <ReturnSettings reseller={reseller} user={user} onChange={this.updateUser.bind(this)} history={history} />} />
                        }

                        <Route path='/klant/instellingen/koppelingen' render={() => <ConnectionSettings reseller={reseller} user={user} history={history} onChange={this.updateUser.bind(this)} />} />

                        <Route path='/klant/instellingen/adresboek' render={() => <AddressBookSetings reseller={reseller} user={user} addressBook={addressBook} />} />

                        {history.location.pathname !== '/klant/instellingen/adresboek' && history.location.pathname !== '/klant/instellingen/koppelingen/webshops' &&
                            <Button
                                style={{marginTop: 15, width: 'fit-content'}}
                                loading={saving}
                                onClick={this.saveSettings.bind(this)}
                            >
                                Opslaan
                            </Button>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default Settings
